import React from "react";
import { Modal, ModalBody, Button, Spinner } from "reactstrap";
// utils
import { formatAmount } from "./formatters";

// Confirmação de cancelamento de uma venda: ícone de alerta, resumo da venda
// (e-mail e valor) e ações "Voltar" / "Cancelar venda", com spinner enquanto processa.
export default function ModalCancelSale({
  isOpen,
  toggle,
  sale,
  loading,
  onConfirm,
}) {
  const amount = formatAmount(sale?.amount);

  return (
    <Modal
      isOpen={isOpen}
      toggle={loading ? undefined : toggle}
      centered
      contentClassName="border-0 shadow-lg modal-cancel-sale"
    >
      <ModalBody className="p-4 text-center">
        <span
          className="avatar-title rounded-circle bg-danger bg-soft text-danger mx-auto mb-3"
          style={{ width: 64, height: 64 }}
        >
          <i className="mdi mdi-alert-outline font-size-24" aria-hidden="true" />
        </span>

        <h5 className="mb-1">Cancelar venda</h5>
        <p className="text-muted mb-3">
          Tem certeza que deseja cancelar esta venda?
        </p>

        <div className="bg-light rounded-3 text-start px-3 py-2 mb-3 font-size-13">
          <div className="d-flex align-items-baseline gap-2">
            <span className="text-muted flex-shrink-0" style={{ width: 52 }}>
              E-mail
            </span>
            <span className="fw-semibold text-break">{sale?.email}</span>
          </div>
          {amount && (
            <div className="d-flex align-items-baseline gap-2 mt-1">
              <span className="text-muted flex-shrink-0" style={{ width: 52 }}>
                Valor
              </span>
              <span className="fw-semibold">{amount}</span>
            </div>
          )}
        </div>

        <p className="text-muted font-size-13 mb-4">
          <i className="mdi mdi-information-outline me-1" aria-hidden="true" />
          Essa ação não pode ser desfeita.
        </p>

        <div className="d-flex justify-content-center gap-2">
          <Button
            color="light"
            className="px-4"
            onClick={toggle}
            disabled={loading}
          >
            Voltar
          </Button>
          <Button
            color="danger"
            className="px-4 d-inline-flex align-items-center gap-2"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading && <Spinner size="sm" />}
            Prosseguir
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}
